import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const mediaUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  return path;
};

export const PLACEHOLDER_IMG =
  "https://static.prod-images.emergentagent.com/jobs/d19db0b9-4d6c-4a45-abc6-252ca7a69ad6/images/b77129b41d4829bb8d16090fe17cc74de1990a9eaec775bd8ac474f75c2850c3.jpeg";

export const LOGO_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_artisan-bakery-demo-6/artifacts/5ko56a7s_IMG-20260813-WA0028.jpg";

export const pimg = (path) => mediaUrl(path) || PLACEHOLDER_IMG;

export const formatINR = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nbh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
};

export default api;
